import * as React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {stylesheet} from 'typestyle';
import {GreenColor, GreyColor, WhiteColor} from '../../styles/colors';

interface SortIconProps {
    filterActive: boolean;
}

export default class FilterIcon extends React.Component<SortIconProps> {
    public render() {
        const {filterActive} = this.props;
        return (
            <span className="fa-layers fa-lg fa-fw">
                {filterActive ? <FontAwesomeIcon icon="square" color={GreenColor} /> : null}
                <FontAwesomeIcon className={filterActive ? iconCss.iconSelected : iconCss.iconDefault} icon="filter" inverse transform={'shrink-6'} />
            </span>
        );
    }
}

const iconCss = stylesheet({
    iconDefault: {
        color: GreyColor,
    },
    iconSelected: {
        color: WhiteColor,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/FilterIcon.tsx